var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { Form } from 'antd';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import RadioGroup from './RadioGroup';
import Checkboxes from './Checkboxes';
import SelectField from './SelectField';
import EditableAnswerField from './EditableAnswerField';
import { getFormInitialValues } from '../helpers/formHelpers';
var EditableField = function (_a) {
    var _b;
    var question = _a.question, setEditValue = _a.setEditValue, isTicketSurvey = _a.isTicketSurvey;
    var form = Form.useForm()[0];
    var answers = ((_b = question === null || question === void 0 ? void 0 : question.answers) === null || _b === void 0 ? void 0 : _b.nodes) || [];
    var kind = question.kind, required = question.required;
    var onInputChange = useCallback(function (v) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!v) {
                        setEditValue([]);
                        return [2 /*return*/];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, form.validateFields([(_a = answers[0]) === null || _a === void 0 ? void 0 : _a.id])];
                case 2:
                    _d.sent();
                    setEditValue([
                        {
                            id: (_b = answers[0]) === null || _b === void 0 ? void 0 : _b.id,
                            user_answer_value: v,
                            kind: (_c = answers[0]) === null || _c === void 0 ? void 0 : _c.kind
                        }
                    ]);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    console.error('Validation failed', error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [form, answers, kind]);
    var onInputDebounce = useDebouncedFunction(onInputChange, 500);
    var item;
    var initialValues = getFormInitialValues(answers.filter(function (i) { return i.answer_value; }));
    switch (kind) {
        case 'radio':
            item = (_jsx(RadioGroup, { answers: answers, setEditValue: setEditValue, form: form, required: required, isTicketSurvey: isTicketSurvey }));
            break;
        case 'checkbox':
        case 'boolean':
            item = (_jsx(Checkboxes, { answers: answers, setEditValue: setEditValue, form: form, required: required, isTicketSurvey: isTicketSurvey }));
            break;
        case 'select':
            item = (_jsx(SelectField, { answers: answers, setEditValue: setEditValue, form: form, required: required, isTicketSurvey: isTicketSurvey }));
            break;
        default:
            item = (_jsx(EditableAnswerField, { kind: kind, required: required, answer: answers[0], onInputChange: onInputDebounce, isTicketSurvey: isTicketSurvey }));
            break;
    }
    return (_jsx(Form, { form: form, initialValues: initialValues, preserve: false, children: item }));
};
export default EditableField;
